import {
  createClient as createSupabaseClient,
  type SupabaseClient,
} from '@supabase/supabase-js'
import { SUPABASE_ANON_KEY, SUPABASE_URL } from '@/config'

/**
 * Без сгенерированных типов БД используем `any`, чтобы PostgREST/RPC не
 * сводились к `never`. Ограничиваем зону эскейпа: три `eslint-disable` тут,
 * и больше нигде.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDb = any

let client: SupabaseClient<AnyDb> | null = null

export function createClient(): SupabaseClient<AnyDb> {
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error(
      'Задайте VITE_SUPABASE_URL и VITE_SUPABASE_ANON_KEY для USE_MOCK=false',
    )
  }
  if (!client) {
    client = createSupabaseClient<AnyDb>(SUPABASE_URL, SUPABASE_ANON_KEY)
  }
  return client
}
